import { useState, type FormEvent } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const info = (location.state as { flash?: string } | null)?.flash ?? '';
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const r = await login(username, password, remember);
      if (r.ok) navigate('/dashboard', { replace: true });
      else setError(r.message || 'Sign in failed');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-vh-100 d-flex flex-column" style={{ background: 'linear-gradient(180deg,#f8f9fe,#fff)' }}>
      <nav className="navbar navbar-dark public-hero">
        <div className="container">
          <Link className="navbar-brand" to="/">
            M3UStudio
          </Link>
          <Link className="btn btn-light btn-sm rounded-pill" to="/register">
            Sign up
          </Link>
        </div>
      </nav>
      <div className="flex-grow-1 d-flex align-items-center py-5">
        <div className="container" style={{ maxWidth: 440 }}>
          <div className="card shadow border-0 rounded-4 overflow-hidden">
            <div
              style={{ height: 4, background: 'linear-gradient(87deg,#5e72e4,#825ee4)' }}
              aria-hidden
            />
            <div className="card-body p-4">
              <p className="small text-uppercase text-primary fw-semibold mb-1">M3UStudio</p>
              <h1 className="h4 fw-bold mb-3">Sign in</h1>
              {info && <div className="alert alert-success py-2 small">{info}</div>}
              {error && <div className="alert alert-danger py-2 small">{error}</div>}
              <form onSubmit={onSubmit}>
                <div className="mb-3">
                  <label className="form-label" htmlFor="u">
                    Email or username
                  </label>
                  <input
                    id="u"
                    className="form-control form-control-lg"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    autoComplete="username"
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label" htmlFor="p">
                    Password
                  </label>
                  <input
                    id="p"
                    type="password"
                    className="form-control form-control-lg"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    autoComplete="current-password"
                    required
                  />
                </div>
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <div className="form-check mb-0">
                    <input
                      id="r"
                      type="checkbox"
                      className="form-check-input"
                      checked={remember}
                      onChange={(e) => setRemember(e.target.checked)}
                    />
                    <label className="form-check-label text-muted small" htmlFor="r">
                      Remember me
                    </label>
                  </div>
                  <Link to="/forgot-password" className="small">
                    Forgot password?
                  </Link>
                </div>
                <button type="submit" className="btn btn-primary w-100 rounded-pill py-2" disabled={loading}>
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" />
                      Signing in…
                    </>
                  ) : (
                    'Sign in'
                  )}
                </button>
              </form>
              <p className="small text-center mt-3 mb-0 text-muted">
                <Link to="/register">Create an account</Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
